import _ from 'lodash';

let stepsToSkip;

function step(stepId) {
    return {
        skipIf: (cond) => {
            if (cond()) {
                stepsToSkip.push(stepId);
            }
        }
    };
}

export default function EndorsementWizardSkipConfig(policyChangeVM) {
    stepsToSkip = [];
    const policyChange = policyChangeVM.value;

    step('EndorsementVehicleChanges').skipIf(() => {
        return _.get(policyChange, 'lobData.privateMotor.selectedChanges.hasVehicleChanges') === false;
    });
    step('EndorsementDriverChanges').skipIf(() => {
        return _.get(policyChange, 'lobData.privateMotor.selectedChanges.hasDriverChanges') === false;
    });
    step('EndorsementCoveragesChanges').skipIf(() => {
        return _.get(policyChange, 'lobData.privateMotor.selectedChanges.hasCoveragesChanges') === false;
    });

    return stepsToSkip;
}
